import axios from "axios";
import { getToken } from "../hooks/actions/sessionActions";
import { trackApiError } from "../analytics/trackApiError";

const Api = axios.create({
  baseURL: process.env.REACT_APP_API_MONITORA,
});

Api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.data?.error === "TokenExpiredError") {
      window.location.href = '/logout';
    } else {
      trackApiError(error);
    }
    return Promise.reject(error);
  }
);

export default Api;
